import { statusBand } from "@/lib/statusScale";

const LABELS = {
  operational_flexibility: "Operational Flexibility",
  communications_readiness: "Communications Readiness",
  vendor_recovery: "Vendor Recovery Readiness",
  data_protection: "Data Protection Readiness",
  staffing_resilience: "Staffing Resilience",
};

export default function ReadinessBar({ category, score }) {
  const b = statusBand(score);
  return (
    <div data-testid={`readiness-${category}`} className="space-y-1.5">
      <div className="flex items-center justify-between text-sm">
        <span className="text-slate-700 rs-txt-body">{LABELS[category] || category}</span>
        <span className="text-slate-500 rs-txt-muted tabular-nums text-xs">{score}/100 · {b.label}</span>
      </div>
      <div className="h-1.5 w-full bg-slate-100 rs-track rounded-full overflow-hidden">
        <div className={`h-full ${b.bar} transition-all duration-500`} style={{ width: `${score}%` }} />
      </div>
    </div>
  );
}
